import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, type TabsProperties } from 'ui';
import { type CommunityTabItem, isCommunityTabItem } from '../../types';

export type P = {
  active: CommunityTabItem;
  isPublicView: boolean;
  onNavigateToCommunityTab: (tab: CommunityTabItem) => void;
};

const CommunityTabs = ({ active, isPublicView, onNavigateToCommunityTab }: P) => {
  const { t } = useTranslation();

  const onTabClick = useCallback(
    (key: string) => {
      if (isCommunityTabItem(key)) {
        onNavigateToCommunityTab(key);
      } else {
        console.warn(`Community tab navigation skipped: invalid tab key "${key}"`);
      }
    },
    [onNavigateToCommunityTab],
  );

  const tabItems = useMemo<TabsProperties['items']>(
    () => [
      ...(isPublicView
        ? []
        : [
            { key: '/feed', label: t('News') },
            { key: '/assets', label: t('Files') },
          ]),
      { key: '/about', label: t('About') },
    ],
    [isPublicView, t],
  );

  return (
    <Tabs
      activeKey={active}
      animated={{ inkBar: false }}
      hasContentHolderHidden
      items={tabItems}
      onTabClick={onTabClick}
    />
  );
};

export default CommunityTabs;
